export var AppType;
(function (AppType) {
    // Default version
    AppType["RL"] = "rl";
    // Jewish Agency
    AppType["JA"] = "ja";
})(AppType || (AppType = {}));
